module.exports = __webpack_public_path__ + "img/emptystate_calendar.a1d2752c.svg";